module.exports = __webpack_public_path__ + "static/icons/icon-legend-wind-8127bce1b8254791d4f1f2775a5eef71.svg";